export default __webpack_public_path__ + "2c5dccd0c2552eb67f137030d836830c.png";